import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CalculatedExpressionParameterDefinition  {
    _originalTypeClassName = "zERP.BO.CalculatedExpressionParameterDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CalculatedExpressionParameterDefinition.translate = translateService;
}
this.Name = null;
this.Description = null;
this.Datatype = null;
this.SampleValue = null;
this.CalculatedExpressionParameterDefinitionKey = null;
this._key = this.CalculatedExpressionParameterDefinitionKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Description:any;
Datatype:any;
SampleValue:any;
private _CalculatedExpressionParameterDefinitionKey:any;
get CalculatedExpressionParameterDefinitionKey(): any {
    return this._CalculatedExpressionParameterDefinitionKey;
  }
set CalculatedExpressionParameterDefinitionKey(value: any) {
    this._CalculatedExpressionParameterDefinitionKey = value;
    this._key = value;
  }

static GetAggreedSalaryInputKey(): any{return "salary_aggreement";
}
static GetBasicSalaryKey(): any{return "basic_salary";
}
static GetBasicSalaryTotalKey(): any{return "total_basic_salary";
}
static GetBonusDailyRateKey(): any{return "bonus_daily_salary";
}
static GetCurrentMonthInputKey(): any{return "current_month";
}
static GetCurrentYearInputKey(): any{return "current_year";
}
static GetDailyRateInputKey(): any{return "daily_salary";
}
static GetEasterDaysKey(): any{return "easter_days";
}
static GetEmploymentRelationshipTypeKey(): any{return "employment_relationship_type";
}
static GetEmploymentTypeKey(): any{return "employment_type";
}
static GetFulltimeAggreedHourlySalaryInputKey(): any{return "fulltime_hourly_salary_aggreement";
}
static GetHourlyRateInputKey(): any{return "hourly_salary";
}
static GetIncreasedDailyRate(): any{return "increased_daily_salary";
}
static GetInsuredDays(): any{return "insured_days";
}
static GetInsuredDaysPerMonthInputKey(): any{return "insured_days_per_month";
}
static GetLeaveBonusDaysInputKey(): any{return "leave_bonus_days";
}
static GetLeaveHours(): any{return "leaves_hours";
}
static GetLeavesAnamoniInputKey(): any{return "leaves_anamoni";
}
static GetLeavesAneyApodoxwnInputKey(): any{return "leaves_aney_apodoxwn";
}
static GetLeavesEpidotisiInputKey(): any{return "leaves_epidotisi";
}
static GetLeavesInsuranceDaysInputKey(): any{return "leaves_insurance_days";
}
static GetMonthHoursInputKey(): any{return "month_work_hours";
}
static GetNormalLeavesNotTakenInputKey(): any{return "normal_leave_not_taken";
}
static GetNumberOfChildrenInputKey(): any{return "number_of_children";
}
static GetPayrollPeriodTypeKey(): any{return "payroll_period_type";
}
static GetUserdefinedFMYInputKey(): any{return "userdefined_FMY";
}
static GetWorkDays(): any{return "work_days";
}
static GetWorkDaysPerWeekInputKey(): any{return "work_days_per_week";
}
static GetWorkExpirienceInputKey(): any{return "work_experience";
}
static GetWorkHoursPerDayInputKey(): any{return "work_hours_per_day";
}
static GetWorkHoursPerWeekInputKey(): any{return "work_hours_per_week";
}
static GetXmansDaysKey(): any{return "xmans_days";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CalculatedExpressionParameterDefinitionKey == null || $this.CalculatedExpressionParameterDefinitionKey == 0;
            }


}